/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UndercarriageWearTrendResponse
 */
export interface UndercarriageWearTrendResponse {
    /**
     * 
     * @type {string}
     * @memberof UndercarriageWearTrendResponse
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageWearTrendResponse
     */
    slope?: number;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageWearTrendResponse
     */
    intercept?: number;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageWearTrendResponse
     */
    hoursToLimit?: number | null;
}

/**
 * Check if a given object implements the UndercarriageWearTrendResponse interface.
 */
export function instanceOfUndercarriageWearTrendResponse(value: object): value is UndercarriageWearTrendResponse {
    return true;
}

export function UndercarriageWearTrendResponseFromJSON(json: any): UndercarriageWearTrendResponse {
    return UndercarriageWearTrendResponseFromJSONTyped(json, false);
}

export function UndercarriageWearTrendResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UndercarriageWearTrendResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'slope': json['slope'] == null ? undefined : json['slope'],
        'intercept': json['intercept'] == null ? undefined : json['intercept'],
        'hoursToLimit': json['hoursToLimit'] == null ? undefined : json['hoursToLimit'],
    };
}

export function UndercarriageWearTrendResponseToJSON(json: any): UndercarriageWearTrendResponse {
    return UndercarriageWearTrendResponseToJSONTyped(json, false);
}

export function UndercarriageWearTrendResponseToJSONTyped(value?: UndercarriageWearTrendResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'slope': value['slope'],
        'intercept': value['intercept'],
        'hoursToLimit': value['hoursToLimit'],
    };
}

